(() => {
  const HOLD_MS = 2200; // how long to hold scroll after submit (tweak if needed)

  function attachScrollLock(host) {
    const sr = host.shadowRoot;
    if (!sr) return false;

    const form = sr.querySelector('form');
    if (!form || form.__scrollLockBound) return !!form;

    form.__scrollLockBound = true;

    form.addEventListener('submit', () => {
      const y = window.pageYOffset || 0;

      // Pin the wrapper height to prevent layout shift
      const wrapper =
        host.closest('.newsletter-form') || host.parentElement || document.body;

      if (wrapper) {
        const h = Math.max(wrapper.getBoundingClientRect().height, 76);
        wrapper.style.minHeight = h + 'px';
        wrapper.style.height = h + 'px';
        wrapper.style.overflowAnchor = 'none';
      }

      // Blur focused element to avoid auto-scroll
      setTimeout(() => document.activeElement && document.activeElement.blur(), 0);

      // Temporarily disable auto restoration
      const prevSR = history.scrollRestoration;
      try { history.scrollRestoration = 'manual'; } catch (_) {}

      // Keep the viewport fixed briefly while the app swaps DOM
      const start = performance.now();
      let rafId = 0;
      const hold = () => {
        window.scrollTo(0, y);
        if (performance.now() - start < HOLD_MS) {
          rafId = requestAnimationFrame(hold);
        } else {
          cancelAnimationFrame(rafId);
          // release height after success state settles
          setTimeout(() => {
            if (wrapper) {
              wrapper.style.height = '';
              wrapper.style.minHeight = '76px'; // leave a small guard
            }
            try { history.scrollRestoration = prevSR; } catch (_) {}
          }, 400);
        }
      };
      hold();
    }, { capture: true });

    return true;
  }

  // Attach for a single wrapper
  function prepareWrapper(wrapper) {
    if (wrapper.__nlPrepared) return;
    wrapper.__nlPrepared = true;

    const tryAttach = () => {
      const host = wrapper.querySelector('form-embed');
      if (host && host.shadowRoot) attachScrollLock(host);
    };

    // try now, when the custom element upgrades, and on wrapper mutations
    tryAttach();
    window.customElements?.whenDefined?.('form-embed').then(tryAttach);

    const mo = new MutationObserver(() => {
      tryAttach();
      // If attached, we can disconnect (no constant observing)
      const host = wrapper.querySelector('form-embed');
      if (host?.shadowRoot && host.shadowRoot.querySelector('form')?.__scrollLockBound) {
        mo.disconnect();
      }
    });
    mo.observe(wrapper, { childList: true, subtree: true });
  }

  function init() {
    // Prepare each newsletter block (keeps scope tight)
    document.querySelectorAll('.newsletter-form').forEach(prepareWrapper);

    // If a block is added later (e.g., theme editor or sections), watch the body lightly
    const addObs = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (!(n instanceof HTMLElement)) continue;
          if (n.matches?.('.newsletter-form')) prepareWrapper(n);
          n.querySelectorAll?.('.newsletter-form').forEach(prepareWrapper);
        }
      }
    });
    addObs.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', () => {
      document.querySelectorAll('.newsletter-form').forEach(prepareWrapper);
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
